<jw-modal [id]='this.modalId'>
      @if (this.target) {
        <h3 class='header'>{{ this.mode === 'complete' ? 'Mark inspection done' : 'Change due date' }}</h3>
        <br />
        <p>
          <strong>{{ this.target.registration }}</strong> &ndash; {{ this.target.typeName }}<br />
          Due {{ this.ukDate(this.target.nextDueDate) }}
          @if (this.target.lastDoneDate) { &middot; last done {{ this.ukDate(this.target.lastDoneDate) }} }
        </p>
        @if (this.error) { <div class='alert alert-danger'>{{ this.error }}</div> }
        @if (this.mode === 'complete') {
          <div class='form-group'>
            <label>Date done</label>
            <input type='date' class='form-control' [(ngModel)]='this.doneDate' [max]='this.today'>
            <small class='text-muted'>The next one is scheduled from this date.</small>
          </div>
          <div class='form-group'>
            <label>Notes (optional)</label>
            <textarea class='form-control' rows='3' [(ngModel)]='this.notes'></textarea>
          </div>
        } @else {
          <div class='form-group'>
            <label>Next due date</label>
            <input type='date' class='form-control' [(ngModel)]='this.dueDate'>
          </div>
        }
        <button class='btn btn-secondary' (click)='this.save()' [disabled]='this.busy'><i class='fas fa-check'></i> Save</button>&nbsp;
        <button class='btn btn-secondary' (click)='this.close()'>Cancel</button>
      }
</jw-modal>
